export const LOGIN = "LOGIN";
export const UPDATE_AUTH_FIELD = "UPDATE_AUTH_FIELD";
export const ASYNC_START = "ASYNC_START";
export const ASYNC_END = "ASYNC_END";
export const INIT_AUTH = "INIT_AUTH";
export const LOGOUT = "LOGOUT";
export const USER_FETCHED = "USER_FETCHED";
export const USER_UPDATED = "USER_UPDATED";
export const REGISTER = "REGISTER"
export const OTP_REQUEST = "OTP_REQUEST"

export const CATEGORY_LOADED = "CATEGORY_LOADED";
export const PRODUCTS_LOADED = "PRODUCTS_LOADED";
export const SINGLE_PRODUCT_LOADED = "SINGLE_PRODUCT_LOADED";
export const LISTING_VIEW_PRODUCTS_LOADED = "LISTING_VIEW_PRODUCTS_LOADED";

export const APP_LOADED = "APP_LOADED";
export const APP_LOADING = "APP_LOADING";
export const ADDRESS_SELECTED = "ADDRESS_SELECTED";

export const ADDRESS_LOADED = "ADDRESS_LOADED";
export const ADDRESS_SAVED = "ADDRESS_SAVED";
export const ADDRESS_UPDATED = "ADDRESS_UPDATED";
export const ADDRESS_DELETED = "ADDRESS_DELETED";
export const DELIVERY_ADDRESS_REMOVED = "DELIVERY_ADDRESS_REMOVED";
export const PINCODE_VERIFIED = "PINCODE_VERIFIED";
export const UPDATE_ADDADDRESS_FIELD = "UPDATE_ADDADDRESS_FIELD"
export const UPDATE_EDITADDRESS_FIELD = "UPDATE_EDITADDRESS_FIELD"
export const UPDATE_ADDRESS_FIELD = "UPDATE_ADDRESS_FIELD"

export const CART_PRODUCT_ADDED = "CART_PRODUCT_ADDED";
export const CART_PRODUCT_REMOVED = "CART_PRODUCT_REMOVED";
export const CART_PRODUCT_UPDATED = "CART_PRODUCT_UPDATED";
export const CART_COUPONS_LOADED = "CART_COUPONS_LOADED";
export const CART_COUPON_APPLIED = "CART_COUPON_APPLIED";
export const CART_TAX_APPLIED = "CART_TAX_APPLIED";
export const CART_EVALUATED = "CART_EVALUATED";
export const CART_CLEARED = "CART_CLEARED";
export const CART_ITEMS_LOADED = "CART_ITEMS_LOADED";

export const ALL_PRODUCTS_LOADED = "ALL_PRODUCTS_LOADED";
export const RECOMMENDED_PRODUCTS_LOADED = "RECOMMENDED_PRODUCTS_LOADED";
export const EXCLUSIVE_PRODUCTS_LOADED = "EXCLUSIVE_PRODUCTS_LOADED";
export const POPULAR_PRODUCTS_LOADED = "POPULAR_PRODUCTS_LOADED";
export const OTHER_PRODUCTS_LOADED = "OTHER_PRODUCTS_LOADED";
export const ORDER_SUCCESS = "ORDER_SUCCESS";
export const ORDERS_LOADED = "ORDERS_LOADED";
export const ORDER_CANCELLED = "ORDER_CANCELLED";
export const ORDER_PLACED_CLEARED = "ORDER_PLACED_CLEARED";
export const SLIDER_IMAGES_LOADED = "SLIDER_IMAGES_LOADED";

export const SEARCH_PRODUCT = "SEARCH_PRODUCT";
export const SEARCH_CATEGORY = "SEARCH_CATEGORY";
export const SEARCH_BRAND = "SEARCH_BRAND";
export const SEARCH_RESET = "SEARCH_RESET";

export const DELIVERY_SLOTS_LOADED = "DELIVERY_SLOTS_LOADED";
export const DELIVERY_SLOT_SELECTED = "DELIVERY_SLOT_SELECTED";

export const APP_SETTINGS_LOADED = "APP_SETTINGS_LOADED";
export const BRANDS_LOADED = "BRANDS_LOADED";
export const BRAND_PRODUCTS_LOADED = "BRAND_PRODUCTS_LOADED";

export const SUBCATEGORIES_LOADED = "SUBCATEGORIES_LOADED";
export const SEND_ENQUIRY = "SEND_ENQUIRY";
export const DELIVERY_AREAS_LOADED = "DELIVERY_AREAS_LOADED";
export const DELIVERY_AREA_SELECTED = "DELIVERY_AREA_SELECTED";
export const ENQUIRY_LIST_LOADED = "ENQUIRY_LIST_LOADED";
export const CMS_LIST_LOADED = "CMS_LIST_LOADED";
export const SET_DEVICE_TOKEN = "SET_DEVICE_TOKEN";
export const SET_PAYMENT_TYPE = "SET_PAYMENT_TYPE";
export const SINGLE_ORDER_LOADED = "SINGLE_ORDER_LOADED";